import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatToMaxFourDigits } from '@flexo/general';

interface InformationCardContentDynamicLabelProps {
  description: string;
  id: string;
  descriptionNoData?: string|null;
  additionalFields: Array<{
    field: string;
    label: string;
  }>;
  overviewKpiApiData?: Array<any>;
}

const InformationCardContentLabel: React.FC<
  InformationCardContentDynamicLabelProps
> = ({ description, id, additionalFields, overviewKpiApiData, descriptionNoData = null }) => {
  const { t } = useTranslation();

  console.log('_descriptionNoData', descriptionNoData);

  const availableExtraData = (overviewKpiApiData || [])
    .filter(
      (kpi: any) =>
        kpi.value !== null && kpi.value !== undefined && kpi.value !== ''
    )
    .filter((kpi: any) =>
      additionalFields.some((field: any) => field.field === kpi.name)
    )
    .sort((a: any, b: any) => {
      const indexA = additionalFields.findIndex(
        (field: any) => field.field === a.name
      );
      const indexB = additionalFields.findIndex(
        (field: any) => field.field === b.name
      );
      return indexA - indexB;
    })
    .map((kpi: any) => {
      const matchingField = additionalFields.find(
        (field: any) => field.field === kpi.name
      );
      return {
        ...kpi,
        ...matchingField,
        matchingFieldLabel: matchingField?.label,
        originalKpiValue: kpi.value,
        originalKpiName: kpi.name,
      };
    });

  return (
    <>
      {availableExtraData.length > 1 ? (
        availableExtraData.map((kpi: any, kpi_i: number) => (
          <div key={`${id}-${kpi_i}-label`} className="color-hive-greyscale-600 mb-0_5" style={{width: '100%'}}>
              <span className="font-flexo-semibold heading5">{t(kpi.matchingFieldLabel)}</span> {kpi.unit}{formatToMaxFourDigits(kpi.originalKpiValue)}
            </div>
        ))
      ) : (
        <span key={`${id}-label`} className="paragraph">
          {descriptionNoData ? t(descriptionNoData) : t(description)}
        </span>
      )}
    </>
  );
};

export default InformationCardContentLabel;
